module.exports = __webpack_public_path__ + "img/young-prince.75689011.png";